export default "__VITE_ASSET__7QlOi8OM__"